(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pointerFineQuery = window.matchMedia('(pointer: fine)');

  function applyMotionPreference() {
    root.classList.toggle('dbr-reduced-motion', reduceMotionQuery.matches);
  }
  applyMotionPreference();
  reduceMotionQuery.addEventListener('change', applyMotionPreference);

  /* Header scroll state -- compact state engages after ~48px of downward
     scroll (matches the correct state immediately on load if the page is
     restored already scrolled). rAF-throttled so fast/inertial scrolling
     never runs the toggle more than once per frame. */
  var header = document.querySelector('[data-dbr-header]');
  if (header) {
    var headerScrollTicking = false;
    var toggleHeaderState = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 48);
      headerScrollTicking = false;
    };
    toggleHeaderState();
    window.addEventListener(
      'scroll',
      function () {
        if (headerScrollTicking) return;
        headerScrollTicking = true;
        requestAnimationFrame(toggleHeaderState);
      },
      { passive: true }
    );
  }

  /* Mobile menu open/close, focus trap and scroll lock live in
     assets/dbr-mobile-menu.js, loaded from sections/dbr-header.liquid. */

  /* Hero parallax — desktop, fine pointer, motion allowed only */
  document.querySelectorAll('[data-dbr-hero][data-parallax="true"]').forEach(function (hero) {
    var media = hero.querySelector('[data-dbr-hero-media]');
    if (!media || reduceMotionQuery.matches || !pointerFineQuery.matches) return;

    var frame = null;
    var targetX = 0;
    var targetY = 0;
    var currentX = 0;
    var currentY = 0;
    /* Below this delta the lerp has visually settled -- stop scheduling
       frames rather than running an invisible rAF loop for the rest of the
       page's life. A later pointermove restarts it. */
    var restEpsilon = 0.02;

    function render() {
      currentX += (targetX - currentX) * 0.06;
      currentY += (targetY - currentY) * 0.06;
      media.style.setProperty('--dbr-parallax-x', currentX.toFixed(2) + 'px');
      media.style.setProperty('--dbr-parallax-y', currentY.toFixed(2) + 'px');
      if (Math.abs(targetX - currentX) < restEpsilon && Math.abs(targetY - currentY) < restEpsilon) {
        frame = null;
        return;
      }
      frame = requestAnimationFrame(render);
    }

    function ensureRunning() {
      if (frame === null) frame = requestAnimationFrame(render);
    }

    hero.addEventListener('pointermove', function (event) {
      var rect = hero.getBoundingClientRect();
      var relX = (event.clientX - rect.left) / rect.width - 0.5;
      var relY = (event.clientY - rect.top) / rect.height - 0.5;
      targetX = relX * -16;
      targetY = relY * -10;
      ensureRunning();
    });

    hero.addEventListener('pointerleave', function () {
      targetX = 0;
      targetY = 0;
      ensureRunning();
    });
  });

  /* Generic scroll-reveal utility for future sections */
  var revealEls = document.querySelectorAll('[data-dbr-reveal]');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );
      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  /* Reactive background — subtle pointer-driven atmosphere.
     Desktop fine-pointer only; lerp factor kept low so movement visibly
     lags the pointer instead of tracking it (avoids a "cursor glow" feel). */
  if (pointerFineQuery.matches && !reduceMotionQuery.matches) {
    var targetPX = 0;
    var targetPY = 0;
    var curPX = 0;
    var curPY = 0;
    var maxOffset = 26;
    var pointerFrame = null;
    var restEpsilon = 0.05;

    function tickPointerField() {
      curPX += (targetPX - curPX) * 0.02;
      curPY += (targetPY - curPY) * 0.02;
      root.style.setProperty('--dbr-pointer-x', curPX.toFixed(1) + 'px');
      root.style.setProperty('--dbr-pointer-y', curPY.toFixed(1) + 'px');
      if (Math.abs(targetPX - curPX) < restEpsilon && Math.abs(targetPY - curPY) < restEpsilon) {
        pointerFrame = null;
        return;
      }
      pointerFrame = requestAnimationFrame(tickPointerField);
    }

    window.addEventListener(
      'pointermove',
      function (event) {
        targetPX = (event.clientX / window.innerWidth - 0.5) * 2 * maxOffset;
        targetPY = (event.clientY / window.innerHeight - 0.5) * 2 * maxOffset;
        if (pointerFrame === null) pointerFrame = requestAnimationFrame(tickPointerField);
      },
      { passive: true }
    );
  }
})();
